import module from 'recursoshumanos/module.js'

const schema = {
  indice: 'number',
  resultados: {
    id_movimiento: 'number',
    estatus: 'boolean',
    salario_base: 'number',
  },
}

export class RecursosHumanosLotesIMSSCoincidenciasService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, data) {
    return this.$http.post('/api/recursos_humanos/lotes_imss/coincidencias', data, {
      params: {empresa_id: empresaId},
      schema,
      headers: {
        'X-HTTP-Method-Override': 'GET',
      },
    })
  }
}

module.service('RecursosHumanosLotesIMSSCoincidencias', RecursosHumanosLotesIMSSCoincidenciasService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/LotesIMSS/Coincidencias.js